import { createSlice } from '@reduxjs/toolkit';
import { LeadsHabiState } from './state';
import { listHabiLeadsStacks } from './thunks';


export const initialState: LeadsHabiState = {
    list: [],
    loading: false,
    page: 1,
};
export const leadsHabiSlice = createSlice({
    name: 'leads_habi',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(listHabiLeadsStacks.fulfilled, (state, action) => {
            const { list } = action.payload;
            state.list = list;
        });
        builder.addCase(listHabiLeadsStacks.pending, (state, action) => {

        });
        builder.addCase(listHabiLeadsStacks.rejected, (state, action) => {

        });
    }
});
// export const { } = userSlice.actions;

export default leadsHabiSlice.reducer;
